import { styled } from '@components-shared/src/stitches';

export const DisplayToggle = styled('div', {
  display: 'none',
  variants: {
    media: {
      laptop: {
        '@laptop': {
          display: 'block',
        },
      },
      notLaptop: {
        display: 'block',
        '@laptop': {
          display: 'none',
        },
      },
      tablet: {
        '@tablet': {
          display: 'block',
        },
      },
      notTablet: {
        display: 'block',
        '@tablet': {
          display: 'none',
        },
      },
      tabletLandscape: {
        '@tabletLandscape': {
          display: 'block',
        },
      },
      notTabletLandscape: {
        display: 'block',
        '@tabletLandscape': {
          display: 'none',
        },
      },
    },
  },
});
